import React from "react";
import {
  Card,
  Group,
  Title,
  Avatar,
  Text,
  Button,
  Stack,
  Divider,
} from "@mantine/core";
import { IconBug, IconPdf } from "@tabler/icons-react";

export default function BugAttachmentPdf() {
  const attachments = [
    { id: 1, fileName: "Image3.jpg" },
    { id: 2, fileName: "Image3.jpg" },
    { id: 3, fileName: "Image3.jpg" },
    { id: 4, fileName: "Image3.jpg" },
    { id: 5, fileName: "Image3.jpg" },
  ];

  return (
    <Card shadow="sm" radius="md" withBorder style={{ maxWidth: 400 }}>
      <Group position="apart" mb="md">
        <Title order={4} color="red">
          Bug Image Attached
        </Title>
      </Group>

      <Stack spacing={0}>
        {attachments.map((item, idx) => (
          <React.Fragment key={item.id}>
            <Group position="apart" py="sm">
              <Group spacing="sm">
                <Avatar radius="xl" size={36} color="blue" variant="filled">
                  <IconPdf size={18} />
                </Avatar>
                <Text>{item.fileName}</Text>
              </Group>
              <Button size="xs" variant="light" color="blue">
                Download
              </Button>
            </Group>
            {idx < attachments.length - 1 && <Divider my={0} />}
          </React.Fragment>
        ))}
      </Stack>
    </Card>
  );
}
